import React, { useEffect, useState, useMemo, useRef } from "react";
import "../../StyleSheet/MainComponent/Role/Role.scss";
import { useDispatch, useSelector } from "react-redux";
import { json, useNavigate } from "react-router-dom";
import {
  RetrieveInvoiceActions,
  RetrieveNewInvoiceActions,
  setprojectListgetdropActions,
  setplantListgetdropActions,
  setprojectwbsListgetdropActions,
} from "../../Redux/Slice";
import ReactTable from "../../Component/AppComponent/Table";
import home from "../../Assets/AppComponent/Logo/Home.svg";
import invoiceDashboard from "../../Assets/AppComponent/Images/invoiceDash.svg";

import Header from "../../Component/AppComponent/Header/Header";
import { DatePicker, DateRangePicker, SelectPicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import axios from "axios";
import {
  exceldatadownloadapi,
  newexceldatadownloadapi,
} from "../../Context/apidata";
import { store } from "../../Redux/Store";
import Select from "react-select";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { FaRegFilePdf } from "react-icons/fa6";

const Dashboard = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const navigate = useNavigate();
  const RetrieveInvoiceRes = useSelector((state) => state.RetrieveInvoiceData);
  const dispatch = useDispatch();
  const [tabledata, settabledata] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [datacount, setdatacount] = useState(0);
  const [tableDatacount, setTableDatacount] = useState(0);
  const [dateRange, setDateRange] = useState(false);
  const [monthRange, setMonthRange] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selecteddata, setselecteddata] = useState("all");
  const [date, setDate] = useState("");
  const [dateValue, setDateValue] = useState();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const currentDate = new Date();
    const month = currentDate.toLocaleString("en-us", { month: "short" });
    const year = currentDate.getFullYear();
    setDate(`${month} ${year}`);
  }, []);

  const disableFutureDates = (date) => {
    const today = new Date();
    return date > today; // Disable future dates
  };

  const selectdata = [
    { label: "All", value: "all" },
    { label: "Sent", value: "True" },
    { label: "Failed", value: "False" },
  ];

  const [defaultvalue, setdefaultvalue] = useState([
    { value: "all", label: "All" },
  ]);
  const [plantNameFeeder, setPlantNameFeeder] = useState([]);
  const [projectNameFeeder, setProjectNameFeeder] = useState([]);
  const [projectWbsNameFeeder, setProjectWbsNameFeeder] = useState([]);

  const [plantSelected, setPlantSelected] = useState([
    { value: "all", label: "All" },
  ]);
  const [projectSelected, setProjectSelected] = useState([
    { value: "all", label: "All" },
  ]);
  const [projectWbsSelected, setProjectWbsSelected] = useState([
    { value: "all", label: "All" },
  ]);
  const [clientStatus, setClientStatus] = useState("all");
  const clientStatusData = [
    { label: "All", value: "all" },
    { label: "UDS PORTAL", value: true },
    { label: "OTHER PORTAL", value: false },
  ];
  const [emailStatus, setEmailStatus] = useState("all");
  const emailStatusData = [
    { label: "All", value: "all" },
    { label: "Sent", value: true },
    { label: "Failed", value: false },
  ];

  const plantNames = useSelector(
    (state) => state.plantListgetdropdata.plantListgetdrop,
  );
  const projectNames = useSelector(
    (state) => state.projectListgetdropdata.projectListgetdrop,
  );
  const projectWbsNames = useSelector(
    (state) => state.projectwbsListgetdropdata.projectwbsListgetdrop,
  );

  useEffect(() => {
    setPlantNameFeeder(plantNames);
  }, [plantNames]);

  useEffect(() => {
    setProjectNameFeeder(projectNames);
  }, [projectNames]);
  // <---------Setting project wbs list in ProjectWbsNameFeeder.--------------->

  useEffect(() => {
    setProjectWbsNameFeeder(projectWbsNames);
  }, [projectWbsNames]);

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(priorDate);
  const [range, setrange] = useState([it, it]);
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  useEffect(() => {
    dispatch(
      RetrieveNewInvoiceActions({
        search: searchQuery,
        // date_gt: range[0],
        // date_lt: range[1],
        month_year: date,
        page: dtpageindex,
        client_status: clientStatus,

        plant: plantSelected[0]?.value ? plantSelected[0]["value"] : null,
        project: projectSelected[0]?.value ? projectSelected[0]["value"] : null,
        project_wbs: projectWbsSelected[0]?.value
          ? projectWbsSelected[0]["value"]
          : null,
      }),
    );
  }, [
    searchQuery,
    range,
    clientStatus,
    dtpageindex,
    plantSelected,
    projectSelected,
    projectWbsSelected,
    date,
    dispatch,
  ]);

  useEffect(() => {
    //console.log(RetrieveInvoiceRes);
    if (RetrieveInvoiceRes?.RetrieveInvoiceData?.data) {
      settabledata(RetrieveInvoiceRes.RetrieveInvoiceData.data);
      setdatacount(RetrieveInvoiceRes.RetrieveInvoiceData.summary);
      setTableDatacount(RetrieveInvoiceRes.RetrieveInvoiceData.values);
    } else {
      settabledata([]);
    }
  }, [RetrieveInvoiceRes]);
  const breadcrumbsData = [
    {
      id: "1",
      href: "/",
      source: invoiceDashboard,
      title: "INVOICE DASHBOARD",
    },
  ];
  function formatArray(arr) {
    return JSON.stringify(
      arr.map((str) =>
        str?.length > 30 ? str?.substring(0, 30) + "..." : str,
      ),
    );
  }
  const InvoiceColumn = useMemo(
    () => [
      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          var dateTimeString = row.row.original.created_at;

          // Split the string into date and time parts using 'T' as the delimiter
          var parts = dateTimeString.split("T");

          // Extract date and time
          var datePart = parts[0]; // "2024-05-13"
          var timePart = parts[1]; // "13:23:47.348708"
          return (
            <>
              <span>Date: {datePart} </span>
              <br></br>
              <span>Time: {timePart}</span>
            </>
          );
        },
      },
      {
        Header: "Customer Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.project != null
                  ? row.row.original.project.c_name
                  : "--"}
              </span>
            </>
          );
        },
      },

      {
        Header: "Plant",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.plant != null
                  ? row.row.original.plant.plant
                  : "--"}
              </span>
            </>
          );
        },
      },
      {
        Header: "Project",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.project != null
                  ? row.row.original.project.project
                  : "--"}
              </span>
            </>
          );
        },
      },
      {
        Header: "Project Wbs",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {/* <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              > */}
              <span>
                {row.row.original.project_wbs != null
                  ? row.row.original.project_wbs.project_wbs
                  : "--"}
              </span>
              {/* </div> */}
            </>
          );
        },
      },
      // {
      //   Header: "Status",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         {/* <div
      //           style={{
      //             width: "50%",
      //             margin: "0 auto",
      //             display: "flex",
      //             justifyContent: "flex-start",
      //             alignItems: "center",
      //           }}
      //         > */}
      //         <span>
      //           {row.row.original.email_status == true
      //             ? "Sent"
      //             : "Failed"}
      //         </span>
      //         {/* </div> */}
      //       </>
      //     );
      //   },
      // },
      {
        Header: "Invoice Count",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {/* <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              > */}
              <span>
                {row.row.original.invoice_id != null
                  ? row.row.original.invoice_id.length
                  : "--"}
              </span>
              {/* </div> */}
            </>
          );
        },
      },

      {
        Header: "Documents",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {/* <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              > */}
              {row.row.original.invoice_zip != null ? (
                <a
                  href={row.row.original.invoice_zip}
                  onClick={(e) => {
                    const parts = row.row.original.invoice_zip.split("/media");
                    const urlAfterMedia =
                      parts.length > 1 ? "/media" + parts[1] : "";
                    //console.log(urlAfterMedia);
                    window.open(String(row.row.original.invoice_zip), "_blank");
                  }}
                >
                  Download Invoice
                </a>
              ) : (
                "--"
              )}
              {/* </div> */}
            </>
          );
        },
      },
    ],
    [],
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },

    {
      label: "Last week",
      closeOverlay: false,
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      appearance: "default",
    },
    {
      label: "Next week",
      closeOverlay: false,
      value: (value, index) => {
        // //console.log(value);
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
        ];
      },
      appearance: "default",
    },
  ];
  const handlechangedate = (name, value) => {
    // let data =value.slice(0, 10)
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };
  const exceldatadownload = (type) => {
    window.open(
      newexceldatadownloadapi +
        `?&id=${store.getState().users.UserData.data.id}&plant=${
          plantSelected?.[0]?.value || "all"
        }&export_type=${type}&client_status=${clientStatus}&project=${
          projectSelected?.[0]?.value || "all"
        }&project_wbs=${
          projectWbsSelected?.[0]?.value || "all"
        }&month_year=${date}`,
      "_blank",
    );
  };

  useEffect(() => {
    dispatch(setplantListgetdropActions());
  }, []);

  useEffect(() => {
    if (plantSelected.length !== 0) {
      if (plantSelected[0].value != "all") {
        dispatch(setprojectListgetdropActions({ id: plantSelected[0].value }));
      }
    }
  }, [plantSelected, projectSelected, dispatch]);

  useEffect(() => {
    if (projectSelected.length !== 0) {
      if (projectSelected[0].value != "all") {
        dispatch(
          setprojectwbsListgetdropActions({ id: projectSelected[0].value }),
        );
      }
    }
  }, [projectSelected, dispatch]);

  useEffect(() => {
    if (projectWbsSelected.length !== 0) {
    }
  }, [projectWbsSelected, projectSelected, dispatch]);

  const customStyles = {
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...base,
        background: isFocused
          ? "rgba(242, 102, 57, 0.7)"
          : isDisabled
            ? "rgb(255,255,255)"
            : "transparent",
        color: isFocused ? "white" : "black",
        ":active": {
          backgroundColor: "rgba(242, 102, 57, 0.7)",
        },
      };
    },
  };

  const projectwbsselect = (e) => {
    if (e) {
      setProjectWbsSelected([{ value: e.value, label: e.label }]);
    } else {
      setProjectWbsSelected([]);
    }
  };

  const currentDate = new Date().toISOString().split("T")[0]; // Get today's date in "YYYY-MM-DD" format
  const isDisabled = range !== currentDate;
  // Disable if the range is different from the current date
  console.log(isDisabled, "klasjkaksjldjkasjklkjlas", currentDate, range[0]);
  useEffect(() => {
    if (range[0] === range[1]) {
      setDateRange(false);
      console.log("first1111111111111111111", range[0], range[1], currentDate);
    } else {
      setDateRange(true);
      console.log("2222222222222222222222222");
    }
  }, [range]);
  useEffect(() => {
    const newDate = new Date();
    console.log(newDate, "jksdkjasdaslkdaljs", newDate);
    if (dateValue !== newDate) {
      setMonthRange(false);
    } else {
      setMonthRange(true);
    }
  }, [date]);
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <Header breadCrumbsData={breadcrumbsData} heading="" />

        <div
          className="row"
          style={{
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <div className="col-sm-2 col-lg-2 col-md-2 col-form">
            <label htmlFor="plant" className="form-label">
              {" "}
              PLANT<span style={{ color: "red" }}>*</span>
            </label>
            <div>
              <Select
                className="Selects"
                styles={customStyles}
                isClearable={true}
                name="plant"
                id="plant"
                options={[
                  { value: "all", label: "All" },
                  ...(plantNameFeeder?.map(({ id, plant }) => ({
                    value: id,
                    label: plant,
                  })) || []),
                ]}
                value={plantSelected}
                onChange={(e) => {
                  if (e) {
                    setPlantSelected([{ value: e.value, label: e.label }]);
                    setProjectSelected([]);
                    setProjectWbsSelected([]);
                    setProjectWbsNameFeeder([]);
                  } else {
                    setProjectSelected([]);
                    setProjectWbsSelected([]);
                    setProjectWbsNameFeeder([]);
                  }
                }}
              />
            </div>
          </div>
          <div className="col-sm-2 col-lg-2 col-md-2 col-form">
            {/* -----------Project--------------- */}
            <label htmlFor="project" className="form-label">
              {" "}
              PROJECT<span style={{ color: "red" }}>*</span>
            </label>
            <div>
              <Select
                className="Selects"
                isClearable={true}
                styles={customStyles}
                name="project"
                options={[
                  { value: "all", label: "All" },
                  ...(projectNameFeeder?.map(({ id, project }) => ({
                    value: id,
                    label: project,
                  })) || [
                    {
                      value: "noneSelected",
                      label: "Select a plant to view projects.",
                      isDisabled: true,
                    },
                  ]),
                ]}
                value={projectSelected}
                onChange={(e) => {
                  if (e) {
                    setProjectSelected([{ value: e.value, label: e.label }]);
                    setProjectWbsSelected([]);
                  } else {
                    setProjectWbsSelected([]);
                    setProjectSelected([]);
                  }
                }}
              />
            </div>
          </div>
          <div className="col-sm-2 col-lg-2 col-md-2 col-form">
            {/* <----------------Project WBS---------------------> */}
            <label htmlFor="plant" className="form-label">
              {" "}
              PROJECT WBS
            </label>
            <div>
              <Select
                className="Selects"
                isClearable={true}
                styles={customStyles}
                defaultValue={defaultvalue[0]}
                onChange={(e) => {
                  projectwbsselect(e);
                }}
                options={[
                  { value: "all", label: "All" },
                  ...(projectWbsNameFeeder?.map(({ id, project_wbs }) => ({
                    value: id,
                    label: project_wbs,
                  })) || []),
                ]}
                value={projectWbsSelected}
              />
            </div>
          </div>
          {/* <div style={{ display: "flex", flexDirection: "column" }}>
            <label htmlFor="plant" className="form-label">
              EMAIL STATUS
            </label>
            <SelectPicker
              value={emailStatus}
              searchable={false}
              onChange={setEmailStatus}
              data={emailStatusData}
              style={{ width: 224 }}
            />
          </div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "20px",
            }}
          >
            <label htmlFor="plant" className="form-label">
              MODE
            </label>
            <SelectPicker
              value={clientStatus}
              searchable={false}
              onChange={setClientStatus}
              data={clientStatusData}
              style={{ width: 224 }}
            />
          </div>
          <div class="col-sm-2   col-auto">
            {" "}
            <label htmlFor="plant" className="form-label">
              {" "}
              SELECT PERIOD
            </label>
            <div className="datepicker_dash">
              <DatePicker
                shouldDisableDate={disableFutureDates}
                format="MM-yyyy"
                placement="bottom"
                className="w-100"
                disabled={dateRange}
                value={dateValue || new Date()}
                componentsProps={{
                  actionBar: { clearable: true }, // Show/hide cancel icon
                }}
                onChange={(e) => {
                  var date = new Date(e);
                  setDateValue(date);
                  console.log(date, "kjskjdsasjkdjkas");

                  var month = date.toLocaleString("en-us", {
                    month: "short",
                  }); // Get the short month name
                  var year = date.getFullYear();
                  setDate(`${month} ${year}`);
                }}
              />
              {console.log(dateValue, "kjsdkjksdjas", new Date())}
            </div>
          </div>
          {/* <div class="col-sm-2   col-auto">
            {" "}
            <label htmlFor="plant" className="form-label">
              {" "}
              Date
            </label>
            <div className="datepicker_dash">
              <DateRangePicker
                defaultValue={[new Date(), new Date()]}
                placement={"auto"}
                disabled={monthRange}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                style={{ width: 300, float: "right" }}
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate("validtill", localISOTime);
                    });
                  }
                }}
              />
            </div>
            {console.log(range, "sdlasdasdasdqw", new Date())}
          </div> */}
          {/* <div className="col-sm-2 col-lg-2 col-md-2 col-form">
            <label htmlFor="plant" className="form-label">
              SCHEDULE STATUS
            </label>
            <SelectPicker
              value={selecteddata}
              searchable={false}
              onChange={setselecteddata}
              data={selectdata}
              style={{ width: 224 }}
            />
          </div> */}
        </div>
        <div className="row">
          <div className="col ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-check-circle-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{datacount?.overall_sent_count}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Overall Sent </h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-danger"
                      style={{
                        width: `${datacount?.overall_sent_count / 10}%`,
                      }}
                      aria-valuenow={datacount?.overall_sent_count}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-check-circle-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{datacount?.sent_count}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Sent</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-danger"
                      style={{ width: `${datacount?.sent_count / 10}%` }}
                      aria-valuenow={datacount?.sent_count}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-exclamation-circle-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{datacount?.pending_count}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Pending</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-danger"
                      style={{ width: `${datacount?.pending_count / 10}%` }}
                      aria-valuenow={datacount?.pending_count}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-building-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{datacount?.plant_count}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Total Plant</h6>
                  {/* <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-danger"
                      style={{ width: `${datacount?.plant_count / 10}%` }}
                      aria-valuenow={datacount?.plant_count}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-briefcase-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{datacount?.project_count}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Total Project</h6>
                  {/* <div class="progress progress-sm"> */}
                  {/* <div
                      class="progress-bar bg-danger"
                      style={{ width: `${datacount?.project_count / 10}%` }}
                      aria-valuenow={datacount?.project_count}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div> */}
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col ">
            {/* <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-person-vcard-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{datacount}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Invoice</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-danger"
                      style={{ width: `${datacount / 10}%` }}
                      aria-valuenow={datacount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div className="UserDetails">
          {/* <button
            style={{
              background:
                "linear-gradient(90deg, #F26639 -3.66%, #F79C37 -3.65%, #EF4D39 100.34%)",
            }}
            className="custom-button mr-3"
            onClick={() => navigate("/create_schedule")}
          >
            CREATE
          </button> */}
          {/* <button
            className="download"
            onClick={(e) => {
              exceldatadownload();
            }}
          >
            Download Excel
          </button> */}
          <div className="split-download" ref={dropdownRef}>
            {/* Default Button */}
            <button
              className="main-btn"
              onClick={() => {
                exceldatadownload("excel");
              }}
              style={{
                background:
                  "linear-gradient(90deg, #F26639 -3.66%, #F79C37 -3.65%, #EF4D39 100.34%)",
              }}
            >
              Download Excel
            </button>

            {/* Arrow Button */}
            <button className="arrow-btn" onClick={() => setOpen(!open)}>
              ▼
            </button>

            {/* Dropdown */}
            {open && (
              <div className="downloadDropdown">
                <div
                  className="downloadDropdown-item"
                  onClick={() => {
                    exceldatadownload("excel");
                    setOpen(false);
                  }}
                >
                  <PiMicrosoftExcelLogoFill size={22} color="#F26639" />
                  Excel
                </div>
                <div
                  className="downloadDropdown-item"
                  onClick={() => {
                    exceldatadownload("pdf");
                    setOpen(false);
                  }}
                >
                  <FaRegFilePdf size={20} color="#F26639" />
                  PDF
                </div>
              </div>
            )}
          </div>
        </div>

        <ReactTable
          columns={InvoiceColumn}
          data={tabledata}
          pagesize={pagesize}
          pageindex={pageindex}
          dtpagesize={dtpagesize}
          dtpageindex={dtpageindex}
          datacount={tableDatacount}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          search={true}
        />
      </div>
    </>
  );
};

export default Dashboard;
